"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UISettingsError = void 0;
var _createClass2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _inherits2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper.js"));
var _wrapNativeSuper2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js"));
// API
// Transformed
var UISettingsError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(UISettingsError, _Error);
  var _super = (0, _createSuper2.default)(UISettingsError);
  function UISettingsError() {
    (0, _classCallCheck2.default)(this, UISettingsError);
    return _super.apply(this, arguments);
  }
  return (0, _createClass2.default)(UISettingsError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
exports.UISettingsError = UISettingsError;